import * as React from 'react';
import {
  Grid,
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Icon,
} from '@material-ui/core';
import {
  Edit,
} from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import type { ILabelValuePair } from '../../marking/MarkingInterfaces';
import type { IEditScannerProps, IScannerDetails } from './ScannerInterfaces';
import getScreenlessBinNames from '../../../lib/SWRfetchers/getScreenlessBinNames';

const EditScanner: React.FC<IEditScannerProps> = ({
  isEdit, isFetching, backToAllScanners, handleSaveBtnClicked, formValues, setFormValues,
}) => {
  const { binNames } = getScreenlessBinNames();

  return (
    <>
      <Grid container spacing={0}>
        <Grid lg={5} md={4} xs={12}>
          <Grid item>
            <Box py={1}>
              {/* Hide if on add scanner page. */}
              {isEdit && (
                <>
                  <Grid container xs={4}>
                    <Grid item>
                      <Box p={1}>
                        <Icon>
                          <Edit
                            color="primary"
                          />
                        </Icon>
                      </Box>
                    </Grid>
                    <Grid item>
                      <Box p={1}>
                        <Typography variant="h6" display="inline">{'Edit Scanner'}</Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </>
              )}
            </Box>
          </Grid>
          <Grid item>
            <Box p={2}>
              <Typography variant="h6">
                {'Scanner Information'}
              </Typography>
            </Box>
            <Box p={2}>
              <TextField
                value={formValues.name}
                id="scannerName-value-input"
                label="Name"
                variant="outlined"
                type="string"
                fullWidth
                onChange={(event) => {
                  const inputVal = event.target.value;
                  const tempFormValues: IScannerDetails = { ...formValues, name: inputVal };
                  setFormValues(tempFormValues);
                }}
              />
            </Box>
            <Box p={2}>
              <TextField
                value={formValues.serialNumber}
                id="serialNumber-value-input"
                label="Serial Number"
                variant="outlined"
                type="string"
                fullWidth
                disabled={isEdit}
                onChange={(event) => {
                  const inputVal = event.target.value;
                  const tempFormValues: IScannerDetails = { ...formValues, serialNumber: inputVal };
                  setFormValues(tempFormValues);
                }}
              />
            </Box>
            <Box p={2}>
              <TextField
                value={formValues.ipAddress}
                id="ipAddress-value-input"
                label="IP Address"
                variant="outlined"
                type="string"
                fullWidth
                onChange={(event) => {
                  const inputVal = event.target.value;
                  const tempFormValues: IScannerDetails = { ...formValues, ipAddress: inputVal };
                  setFormValues(tempFormValues);
                }}
              />
            </Box>
            <Box p={2}>
              <TextField
                value={formValues.macAddress}
                id="macAddress-value-input"
                label="Mac Address"
                variant="outlined"
                type="string"
                fullWidth
                onChange={(event) => {
                  const inputVal = event.target.value;
                  const tempFormValues: IScannerDetails = { ...formValues, macAddress: inputVal };
                  setFormValues(tempFormValues);
                }}
              />
            </Box>
            <Box p={2}>
              {
                binNames ? (
                  <Autocomplete
                    value={binNames.find((bin) => bin.label === formValues?.location.label) || { label: '', value: '' }}
                    onChange={(e, d: ILabelValuePair | null) => {
                      if (d) {
                        const tempFormValues: IScannerDetails = { ...formValues, location: d };
                        setFormValues(tempFormValues);
                      }
                    }}
                    autoHighlight
                    autoSelect
                    // TODO: Need help with below, examples from other files do not work,
                    // may have to do with the fetcher.
                    options={binNames.sort((a, b) => a.label.localeCompare(b.label))}
                    getOptionLabel={(option) => option.label.toString()}
                    renderInput={(params) => (
                      <TextField
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...params}
                        id="locations-type-select"
                        label="Location"
                        variant="outlined"
                      />
                    )}
                  />
                ) : (
                  <TextField
                    style={{ width: '100%', height: '56px' }}
                    label="Location"
                    variant="outlined"
                    disabled
                  />
                )
              }
            </Box>
          </Grid>
          <Grid item xs={12} container spacing={2} direction="row-reverse">
            <Box pt={3}>
              <Button onClick={backToAllScanners}>
                <Typography display="inline">{'BACK TO ALL SCANNERS'}</Typography>
              </Button>
              <Button disabled={isFetching} color="primary" variant="contained" onClick={handleSaveBtnClicked}>
                {isFetching ? <CircularProgress size={25} />
                  : 'SAVE CHANGES'}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default EditScanner;
